import { FaCalendarAlt } from "react-icons/fa";
import { FaRegUser, FaUserPlus } from "react-icons/fa6";
import taskImage from "../../assets/Ellipse 35.png";
import imageProfile from "../../assets/images/avatar-2.webp";
import { ACTIONS } from "../../utils/permissions";

export const taskTab = [
  { description: "Créé un logo pour un site web", budget: "50.000FCFA", dateLine: "25/09/2025", nbreDay: "Il y'a 4 jours", image: taskImage, id: 1 },
  { description: "Créé un logo pour un site web", budget: "50.000FCFA", dateLine: "25/09/2025", nbreDay: "Il y'a 4 jours", image: taskImage, id: 2 },
  { description: "Créé un logo pour un site web", budget: "50.000FCFA", dateLine: "25/09/2025", nbreDay: "Il y'a 4 jours", image: taskImage, id: 3 },
  { description: "Créé un logo pour un site web", budget: "50.000FCFA", dateLine: "25/09/2025", nbreDay: "Il y'a 4 jours", image: taskImage, id: 4 },
  { description: "Créé un logo pour un site web", budget: "50.000FCFA", dateLine: "25/09/2025", nbreDay: "Il y'a 4 jours", image: taskImage, id: 5 },
  { description: "Créé un logo pour un site web", budget: "50.000FCFA", dateLine: "25/09/2025", nbreDay: "Il y'a 4 jours", image: taskImage, id: 6 },
]

export const getButtonConfig = (action, task) => {
  const buttonConfigs = {
    [ACTIONS.POSTULER]: {
      text: "Postuler",
      icon: <FaRegUser size={"12px"} />,
      width: "max-lg:w-[45%] max-md:w-[65%]",
      action: ACTIONS.POSTULER
    },
    [ACTIONS.MODIFIER_DATES]: {
      text: "Dates",
      icon: <FaCalendarAlt size={"14px"} />,
      width: "max-2xl:w-[55%] max-lg:w-[35%] max-md:w-[65%]",
      padding: "",
      action: ACTIONS.MODIFIER_DATES
    },
    [ACTIONS.ASSIGNER]: {
      text: task?.assigned_to_id ? "Réassigner" : "Assigner",
      icon: <FaUserPlus size={"16px"} />,
      title: "Ajout au projet",
      width: "max-2xl:w-[55%] max-lg:w-[35%] max-md:w-[65%]",
      padding: "",
      action: ACTIONS.ASSIGNER
    }
  };

  return buttonConfigs[action];
};

export const data = [
  {
    slug: "bakeli-work-2",
    name: "Mamadou Barry",
    date: "1",
    profile: imageProfile,
    message:
      "a postulé sur la tache Intégration dashboard du projet Bakeli Work",
  },
];

export const footerItems = [
  // {
  //   linkOne: {
  //     icon: <IoMail size={22} color="#4A4E68" radius={"14px"} />,
  //     text: "guindyma@gmail.com",
  //   },
  //   linkTwo: {
  //     icon: <FaPhone size={20} color="#4A4E68" />,
  //     text: "+221 77 000 00 00",
  //   },
  // },
  {
    // linkOne: { text: "SA propos de nous", path: "#" },
    // linkTwo: { text: "Customer Support", path: "#" },
    // linkThree: { text: "About Us", path: "#" },
    // linkFour: { text: "Popular Campaign", path: "#" },
    // title: { text: "A propos" },
  },
  // {
  // linkOne: { text: "Nos services", path: "#" },
  // linkTwo: { text: "Privacy Policy", path: "#" },
  // linkThree: { text: "Terms & Conditions", path: "#" },
  // linkFour: { text: "Site Map", path: "#" },
  // linkFive: { text: "Store Hours", path: "#" },
  // title: { text: "Services" },
  // },
  // {
  //   linkOne: { text: "Voir mon compte", path: "#" },
  //   // linkTwo: { text: "Social Media Directories", path: "#" },
  //   // linkThree: { text: "Images & B-roll", path: "#" },
  //   // linkFour: { text: "Permissions", path: "#" },
  //   // linkFive: { text: "Speaker Requests", path: "#" },
  //   title: { text: "Mon compte" },
  // },
  {
    linkOne: {
      text: "Hlm Grand Yoff Villa n°241 Près du terminus des bus Dakar Dem Dikk qui vont à l'AIBD",
      path: "#",
    },
    linkThree: { text: " MAIL : contact@bakeli.tech", path: "#" },
    linkTwo: { text: "TEL : +221 78 546 15 51", path: "#" },
    // linkFour: { text: "Risponsible Supply Chain", path: "#" },
    title: { text: "Nous contacter" },
  },
];